export const overflowEllipsis = () => `
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    overflow: hidden;
    width: calc(100% - 1px);
`;
